<template>
  <v-row>

    <v-col cols="12" md="6">
      <search-box
          :hidden-clear="false"
          label="Cliente"
          popup-label="Selecione um Cliente"
          :id.sync="value.idCliente"
          :nome.sync="value.nome_idCliente"
          :value="cliente"
          :loader-fn="loaderClientes"
          item-key="id"
          item-text="nome">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhum Cliente encontrado
          </p>
        </template>
      </search-box>
    </v-col>
    <v-col cols="12" md="6">
      <lookup-dominio label="Status Envio"
                      v-model="value.statusEnvio"
                      :type="lookups.statusEnvio"
                      :hidden-clear="false"/>
    </v-col>
    <v-col cols="12" md="6">
      <v-text-field label="Data Inicio"
                    dense
                    type="date"
                    v-model="value.dataIni"
                    :value="this.inicioMes"
                    :rules="[
                        this.$validators.string.required,
                  ]"/>
    </v-col>
    <v-col cols="12" md="6">
      <v-text-field label="Data Fim"
                    dense
                    type="date"
                    v-model="value.dataFim"
                    :value="this.fimMes"
                    :rules="[
                        this.$validators.string.required,
                  ]"/>
    </v-col>
  </v-row>
</template>

<script>

import {ItemDeDominio} from "../../../../api/itemsDominio";
import {findAll as findAllClientes} from "../../../../api/clientes";
import LookupDominio from "../../common/LookupDominio";
import OrderInput from "../../common/OrderInput";
import SearchBox from "../../common/SearchBox";
import moment from 'moment';

export default {
  name: "RelatorioLogComunicacaoForm",
  components: {
    SearchBox,
    LookupDominio,
    OrderInput
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      lookups: {
        statusEnvio: ItemDeDominio.STATUS_MENSAGEM,
      },
      loaderClientes(page, search) {
        return findAllClientes(page, {
          nome: search
        })
      },
    }
  },
  computed: {
    cliente() {
      if (this.value.idCliente == null) return null;
      return {
        id: this.value.idCliente,
        nome: this.value.nome_idCliente
      }
    },
    inicioMes: function () {
      if (typeof this.value.dataIni === "undefined"){
        this.value.dataIni = moment().startOf('month').format('YYYY-MM-DD');
      }
    },
    fimMes: function () {
      if (typeof this.value.dataFim === "undefined"){
        this.value.dataFim = moment().endOf('month').format('YYYY-MM-DD');
      }
    },
  },
}
</script>

<style scoped lang="scss">
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}


</style>